<div class="container actionsTop col-12">
  <!-- <button pButton type="button" (click)="showModalEstudantes = true" label="Filtros"></button> -->

  <div class="btns-actions">
    <button pButton type="button" (click)="showModalEstudantes = true" class="btn-filter">
      <i class="pi pi-search"></i>
      Filtros
    </button>

    <div *ngIf="totalBolseiros > 0">
      <button type="button" class="btn-exportar pdf" (click)="downloadPdf()">
        <i class="pi pi-file-pdf"></i>
        Exportar Relatório PDF
      </button>
      <button type="button" class="btn-exportar excel" (click)="downloadExcel()">
        <i class="pi pi-file-excel"></i>
        Exportar Relatório Excel
      </button>
    </div>
  </div>



  <div class="data-filter mt-3 col-12" *ngIf="totalBolseiros > 0">
    <div class="flex justify-content-between align-items-center w-full">
      <span class="fw-bold">
        {{ totalBolseiros }} Estudantes encontrados
        <span class="text-500 font-normal ml-2" *ngIf="pagination.totalPages && pagination.totalPages > 1">
          (Página {{ pagination.pageNumber }} de {{ pagination.totalPages }})
        </span>
      </span>
    </div>
    <article *ngIf="appliedFilters.length > 0">
      <p>Filtros Aplicados</p>
      <div class="filter">
        <span *ngFor="let filter of appliedFilters">{{filter.label}}: {{filter.value}} </span>
      </div>
    </article>
  </div>
  <div class="w-100">
    <app-table *ngIf="totalBolseiros > 0" [pagination]="pagination" [columns]="columns"
      (pageChange)="onPageChange($event)">
    </app-table>
  </div>
  <div class="flex flex-column align-items-center justify-content-center p-5 w-full" *ngIf="carregando">
    <i class="pi pi-spin pi-spinner text-primary" style="font-size: 2.5rem"></i>
    <span class="mt-3 text-600 font-medium">A consultar estudantes e a gerar relatório...</span>
  </div>

  <div class="no-data w-full" *ngIf="totalBolseiros === 0 && !carregando">
    <app-data-void titulo="Nenhum registro encontrado"
      descricao="Clique em filtros e aplique um filtro para iniciar"></app-data-void>
  </div>
</div>

<p-dialog header="Filtros de Estudantes" [draggable]="false" [modal]="true" [(visible)]="showModalEstudantes"
  [style]="{ width: '40rem' }" [closable]="true">

  <form [formGroup]="formEstudantes" class="SetBorder">
    <div class="p-fluid grid">
      <div class="field col-12 d-flex flex-column">
        <label for="titulo">Tipo de Relatório</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="titulo" formControlName="titulo"
          [options]="titlleOptions" optionLabel="label" optionValue="label" placeholder="Seleccione o título"
          class="w-full">
        </p-select>
        <small class="p-error" *ngIf="formEstudantes.get('titulo')?.invalid && formEstudantes.get('titulo')?.touched">
          O tipo do relatório é obrigatório.
        </small>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="anoInscricao">Ano de Inscrição</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="anoInscricao" formControlName="anoInscricao"
          [options]="anoInscricaoOptions" optionLabel="label" optionValue="value" placeholder="Seleccione o ano"
          class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="nivelAcademico">Nível Académico</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="nivelAcademico"
          formControlName="nivelAcademico" [options]="nivelAcademicoOptions" optionLabel="label" optionValue="id"
          placeholder="Seleccione o nível" class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="arearConhecimento">Área de Conhecimento</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="arearConhecimento"
          formControlName="areaConhecimentoId" [options]="areaFormacaoList" optionLabel="label" optionValue="value"
          placeholder="Seleccione a área" class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="curso">Curso</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="curso" formControlName="cursoId"
          [options]="cursoList" optionLabel="label" optionValue="value" placeholder="Seleccione o curso" class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="inicioFormacao">Início da Formação</label>
        <p-datepicker [showClear]="true" appendTo="body" id="inicioFormacao" formControlName="inicioFormacao"
          optionLabel="label" optionValue="value" placeholder="Seleccione a data" class="w-full" showIcon
          iconDisplay="input">
        </p-datepicker>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="fimFormacao">Fim da Formação (Previsão)</label>
        <p-datepicker [showClear]="true" appendTo="body" id="fimFormacao" formControlName="fimFormacao"
          optionLabel="label" optionValue="value" placeholder="Seleccione a data" class="w-full" showIcon
          iconDisplay="input">
        </p-datepicker>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="instituicaoId">Instituição de Ensino</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="instituicaoId" formControlName="instituicaoId"
          [options]="instituicaoEnsinoList" optionLabel="label" optionValue="value"
          placeholder="Seleccione a instituição" class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="paisId">País de Estudo</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="paisId" formControlName="paisId"
          [options]="paisList" optionLabel="label" optionValue="value" placeholder="Seleccione o país" class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="instituicaoGestoraId">Empresa Gestora</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="instituicaoGestoraId"
          formControlName="instituicaoGestoraId" [options]="instituicaoGestoraList" optionLabel="label"
          optionValue="value" placeholder="Seleccione a empresa" class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="genero">Género</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="genero" formControlName="genero"
          [options]="generoOptions" optionLabel="label" optionValue="id" placeholder="Seleccione o género"
          class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="idadeMinima">Idade Mínima</label>
        <p-inputnumber id="idadeMinima" class="w-full" [showButtons]="true" formControlName="idadeMinima" [min]="18"
          [max]="32" placeholder="Informe a idade mínima"></p-inputnumber>
      </div>

      <div class="field col-6 d-flex flex-column">
        <label for="idadeMaxima">Idade Máxima</label>
        <p-inputnumber id="idadeMaxima" class="w-full" [showButtons]="true" formControlName="idadeMaxima" [min]="18"
          [max]="32" placeholder="Informe a idade máxima"></p-inputnumber>
      </div>

      <div class="field col-12 d-flex flex-column">
        <label for="anoCurricular">Ano Curricular</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="anoCurricular" formControlName="anoCurricular"
          [options]="anoCurricularOptions" optionLabel="label" optionValue="value" placeholder="Seleccione o ano"
          class="w-full">
        </p-select>
      </div>

      <div class="field col-12 d-flex flex-column">
        <label for="estadoBolsaId">Estado da Bolsa</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="estadoBolsaId" formControlName="estadoBolsaId"
          [options]="estadoBolsaOptions" optionLabel="label" optionValue="id" placeholder="Seleccione o estado"
          class="w-full">
        </p-select>
      </div>

    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-between align-items-center w-full flex-wrap gap-2">
      <button
        pButton
        type="button"
        label="Limpar Filtros"
        icon="pi pi-filter-slash"
        severity="secondary"
        [text]="true"
        (click)="limparFiltrosEstudantes()">
      </button>

      <div class="flex gap-2 flex-wrap">
        <button
          pButton
          type="button"
          label="Cancelar"
          icon="pi pi-times"
          severity="secondary"
          [outlined]="true"
          (click)="showModalEstudantes = false">
        </button>

        <button
          pButton
          type="button"
          label="Emitir PDF"
          icon="pi pi-file-pdf"
          class="p-button-danger p-button-outlined"
          (click)="emitirPdfComFiltros()">
        </button>

        <button
          pButton
          type="button"
          label="Emitir Excel"
          icon="pi pi-file-excel"
          class="p-button-success p-button-outlined"
          (click)="emitirExcelComFiltros()">
        </button>

        <button
          pButton
          type="button"
          label="Emitir Relatório"
          icon="pi pi-check"
          [loading]="carregando"
          (click)="onSubmit()">
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-toast></p-toast>
